import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { isPrimeurInCart } from '@/utils/productUtils';

export const SecureInfoEspot = ({ espot, isMobile = false, cart }) => {
	const [data, setData] = useState();

	useEffect(() => {
		if (espot) {
			const isPrimeur = isPrimeurInCart(cart);
			const { htmlContent, htmlContentMobile, htmlContentPrimeur, htmlContentPrimeurMobile } = espot;
			const innerHtmlContent = isPrimeur && htmlContentPrimeur ? htmlContentPrimeur : htmlContent;
			const innerHtmlContentMobile = isPrimeur && htmlContentPrimeurMobile ? htmlContentPrimeurMobile : htmlContentMobile;
			const innerHtml = isMobile && innerHtmlContentMobile ? innerHtmlContentMobile : innerHtmlContent;
			setData(innerHtml);
		}
	}, [espot, isMobile, cart]);

	return data ? (
		<div className="espot-html" dangerouslySetInnerHTML={{ __html: data }} data-test-id="espot-html" data-rbf="espot-html" />
	) : null;
};

SecureInfoEspot.propTypes = {
	isMobile: PropTypes.bool,
	cart: PropTypes.object,
	espot: PropTypes.object,
};

export default SecureInfoEspot;
